import { Notifications } from '@mui/icons-material';
import { Badge, Tooltip } from '@mui/material';

export default function UserNotifications() {
  return (
    <Tooltip title="Notifications">
      <Badge badgeContent={2} color="info" sx={{ marginRight: '16px', marginTop: '8px' }}>
        <Notifications sx={{ fontSize: '2.5rem' }} />
      </Badge>
    </Tooltip>
  );
}
